import React, { useState, useRef, useEffect } from "react";
import styles from "./ListCouponCode.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { styled } from "@mui/material/styles";
import Loader from "../../Loader";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { Typography } from "@mui/material";
import { CSVLink } from "react-csv";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { R_PER_PAGE } from "../../../../labels";
import DatePickerSample from "../../DatePicker";
import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";
import toast from "react-hot-toast";

function ListCouponCode() {
  const moment = require("moment-timezone");
  const location = useLocation();
  const { filter_status, filter_search } = location.state || {};
  const txtBSearch = useRef(null); //search icon
  // List data load table
  let page = R_PER_PAGE;
  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState();
  const [updateChipData, setUpdateChipData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [status, setStatus] = useState([]);
  const [isOpen, setIsOpen] = useState({
    type: false,
    category: false,
    status: false,
  });
  const filterRef = useRef(null);
  let filterSearch = [];
  let filterStatus = [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "status"
          );
          if (hasAuthor) {
            const updatedStatus = updateChipData.filter(
              (chipItem) => chipItem.type === "status"
            );
            setStatus(updatedStatus);
          } else {
            setStatus([]);
          }
          setIsOpen((prev) => ({ ...prev, status: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, status]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);
  useEffect(() => {
    if (filter_status && filter_status.length > 0) {
      setStatus(filter_status);
      filterStatus = filter_status;
    } else {
      setStatus(status);
      filterStatus = status;
    }
    if (filter_search && filter_search.length > 0) {
      filterSearch = [{ name: "" + filter_search, type: "search" }];
      setSearchTerm(filter_search);
    } else {
      if (searchTerm) {
        setSearchTerm(searchTerm);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [filter_status, filter_search]);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  useEffect(() => {
    if (isFiltersInitialized && filter_status && filter_status.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      filter_search &&
      filter_search.length > 0
    ) {
      loadListdata();
    }
  }, [filter_status, filter_search, isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);
  function updateStateData() {
    filterStatus = status;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  useEffect(() => {
    setUpdateListData(updateListData);
  }, [updateListData]);
  useEffect(() => {
    loadChipdata();
  }, []);
  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "status") {
      if (checked) {
        setStatus([{ id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    }
  };
  const handleClear = (name, event) => {
    updateStateData();
    if (name === "status") {
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
      loadChipdata();
    }
    // loadChipdata();
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setCurrentPage(1);
      setIsOpen({
        ...isOpen,
        status: false,
      });
    }
  };

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const handleAllClear = () => {
    setSearchTerm([]);
    setStatus([]);
    setUpdateChipData([]);
    // setUpdateListData([]);
    loadListdata();
  };
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        type: false,
        status: !prevState.status,
      }));
      setStatus(updateChipData.filter((ui) => ui.type === "status"));
    }
  };
  function loadListdata() {
    let temptypeon = [];
    let tempStatus = [];
    status.map((obj) => {
      tempStatus.push(obj.id);
    });
    let statusFilter = {
      status: status.length > 0 ? parseInt(status[0].id) : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      user_id: "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/all/coupon/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));

          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            title: item.title,
            coupon_code: item.coupon_code,
            amount: item.amount,
            coupon_used_count: item.coupon_used_count,
            no_user_count: item.no_user_count,
            displayDate: `${moment(item.start_date).format(
              "DD/MM/YYYY"
            )} - ${moment(item.end_date).format("DD/MM/YYYY")}`,
            status:
              item.status === 0
                ? "Expired"
                : item.status === 1
                ? "Active"
                : "Upcoming",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })

      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }
  useEffect(() => {
    filterStatus = status;
  }, [status]);
  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    }
    if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    }
    loadChipdata();
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData?.slice(start, end);

  const handleReadView = (id) => {
    navigate(`/ViewCouponCode/${id}`, {
      state: {
        STATUS: status,
        SEARCH: searchTerm,
      },
    });
  };
  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const formatDate = (start_date, end_date) => {
    return `${moment(start_date).format("DD/MM/YYYY")} - ${moment(
      end_date
    ).format("DD/MM/YYYY")}`;
  };
  const generatePDF = () => {
    const headers = [
      "Title",
      "Coupon Code",
      "Amount",
      "Coupon Applied",
      "Validity",
      "Status",
    ];

    const rows = csvData.map((item, index) => [
      item.title ?? "",
      item.coupon_code ?? "",
      item.amount ?? "",
      `${item.coupon_used_count ?? 0}/${item.no_user_count ?? 0}`,
      item.displayDate ?? "",
      item.status ?? "",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Coupon Code Data",
          headers,
          rows,
          filename: "Couponcode.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Title", key: "title" },
    { label: "Coupon Code", key: "coupon_code" },
    { label: "Amount", key: "amount" },
    { label: "Coupon Used Count", key: "coupon_used_count" },
    { label: "No. of Users Allowed", key: "no_user_count" },
    { label: "Validity", key: "displayDate" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathHeader  global_container p-0`}
    >
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Coupon Codes</h2>
      </div>
      {/* ---------------------------------------------------------------- */}
      <div className="row ">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
          <div class="input-group ">
            <input
              ref={txtBSearch}
              type="text"
              class={styles.Inputs}
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by title, coupon code "
              onKeyDown={handleSearch}
            />
            <span
              class={styles.input_group_text}
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span
                className="material-icons"
                // onClick={handleSearchFocus}
              >
                search
              </span>
            </span>
          </div>
        </div>

        <div className="col-md-8 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                headers={csvHeaders}
                iconName=" file_download "
                filename={"Couponcode.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
            <li class="ListBtnItems">
              <Link
                to="/AddCoupon"
                className="primaryButton "
                variant="primary"
              >
                Create New Coupon Code
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData
                .filter((kl) => kl.name !== "ActiveTab")
                .map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                {/* S.No. */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    S.No
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    import_export{" "}
                  </span>
                </th>
                {/* Course */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "title")}
                  >
                    {" "}
                    Title
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "title")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "coupon_code")}
                  >
                    {" "}
                    Coupon Code
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "coupon_code")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "amount")}
                  >
                    {" "}
                    Amount
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "amount")}
                  >
                    import_export
                  </span>{" "}
                </th>
                {/* <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    {" "}
                    No. of Emails
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    import_export
                  </span>{" "}
                </th> */}
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    {" "}
                    Coupons Applied
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th">
                  <span className="textHead_th">Validity</span>
                </th>
                <th id="th" ref={filterRef}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    {" "}
                    Status
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "no_user_count")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    class={` align-middle material-icons  ${
                      status?.length > 0 || isOpen.status
                        ? styles.active_icons
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {isOpen.status && (
                    <>
                      <div className="filterBoxs_testlist mt-2">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Active"}
                                value={1}
                                checked={status.some((element) => {
                                  if (element.id == 1) {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Active"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "status", "status")
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-green "
                                htmlFor={"Active"}
                              >
                                Active
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Upcoming"}
                                value={2}
                                checked={status.some((element) => {
                                  if (element.id == 2) {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Upcoming"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "status", "status")
                                }
                              />
                              <label
                                className="form-check-label bg-orange filterChipText "
                                htmlFor={"Upcoming"}
                              >
                                Upcoming
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Expired"}
                                value={0}
                                checked={status.some((element) => {
                                  if (element.id == 0) {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Expired"}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "status", "status")
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-danger "
                                htmlFor={"Expired"}
                              >
                                Expired
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("status")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={status.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("status")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td
                    colSpan="15"
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((course, index) => (
                  <tr key={index}>
                    <td id="td">{course.serialNumber}</td>

                    <td id={`${styles.td}tabTh`}>
                      <span
                        className={`${styles.ellipsis}`}
                        title={course.title}
                      >
                        {course.title}
                      </span>
                    </td>
                    <td id="td">{course.coupon_code} </td>
                    <td id="td">{course.amount} </td>

                    {/* <td id="td">{course.no_user_count} </td> */}
                    {/* no. of used */}
                    <td id="td">
                      {course.coupon_used_count}/{course.no_user_count}{" "}
                    </td>

                    <td id="td">
                      <span>
                        {formatDate(course.start_date, course.end_date)}
                      </span>
                    </td>

                    {/* <td id="td">{course.category_code} </td> */}

                    {course.status == 0 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-danger mx-0 ">
                          Expired
                        </span>
                      </td>
                    )}
                    {course.status == 1 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-green mx-0 ">
                          Active
                        </span>
                      </td>
                    )}
                    {course.status == 2 && (
                      <td id={`${styles.td}`}>
                        <span class="filterChipText bg-orange mx-0">
                          Upcoming
                        </span>
                      </td>
                    )}
                    <td id="td">
                      <button
                        className={"view_icon_button"}
                        // onClick={() => handleReadView(course.id)}
                        onClick={(e) => handleReadView(course.id)}
                      >
                        <span className={` visibleicon material-icons`}>
                          visibility
                        </span>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}

export default ListCouponCode;
